import { Component } from "react";
import { connect } from "react-redux";
import SiteMonitoringPlanBloc from "../SiteMonitoringPlanBloc";
import { withStyles } from "@mui/styles";
import { compose } from "redux";
import { createPlan, setExpandedPlanId } from "../../../redux/siteMonitoring/planActions";
import { siteMonitoringIsDisabled } from "../../../redux/siteMonitoring/siteMonitoringActions";

const styles = {
    root: {
        width: "100%",
        marginTop: "5px",
    },
};

class PlansTab extends Component {
    handleChange = (planId) => {
        let collapsing = planId === this.props.expandedPlanId;

        this.props.setExpandedPlanId(collapsing ? null : planId);
    };

    addPlan() {
        this.props.createPlan(this.props.siteMonitoring, this.props.activeUser);
    }

    render() {
        let siteMonitoringDisabled = siteMonitoringIsDisabled(this.props.siteMonitoring, this.props.activeUser);

        const { classes } = this.props;

        if (!this.props.selectedTab) return null;

        let planElements = [];
        this.props.plans.forEach((p) => {
            if (p.deleted) return;

            let planIndex = p.id;

            planElements.push(
                <SiteMonitoringPlanBloc
                    key={planIndex}
                    id={"bloc-plan-" + planIndex}
                    currentPlanId={p.id}
                    disabled={siteMonitoringDisabled}
                    plan={p}
                    onClick={this.handleChange.bind(this)}
                    validated={p.validated}
                />
            );
        });

        let creationIndex = -1;

        planElements.push(
            <SiteMonitoringPlanBloc
                key={creationIndex}
                id={"plan-creation-" + creationIndex}
                disabled={siteMonitoringDisabled}
                addPlan={this.addPlan.bind(this)}
                creationPlan
            />
        );

        return <div className={classes.root}>{planElements.map((pe) => pe)}</div>;
    }
}

const mapStateToProps = (state) => {
    return {
        siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
        plans: state.siteMonitoring.plans,
        activeUser: state.activeUser,
        expandedPlanId: state.siteMonitoring.expandedPlanId,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setExpandedPlanId: (affairId) => dispatch(setExpandedPlanId(affairId)),
        createPlan: (siteMonitoring, user) => dispatch(createPlan(siteMonitoring, user)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(PlansTab);
